<div class="menu-item">
  <svg-icon
      *ngIf="menuItem.icon"
      [key]="menuItem.icon"
      class="bulb-menu-item-icon"
      [fontSize]="'1em'"
  >
  </svg-icon>
  <img
    [src]="menuItem.iconSrc"
    *ngIf="menuItem.iconSrc"
    alt="menu item icon"
    width="20px"
    height="20px"

  >

  <span class="menu-item__label">{{ menuItem.label }}</span>

  <aside *ngIf="menuItem.descriptiveText" class="menu-item__desc">
    {{ menuItem.descriptiveText }}
  </aside>

  <aside *ngIf="menuItem.descriptiveIcon || menuItem.descriptiveIconSrc || menuItem.tooltipLabel"
         class="menu-item__descriptive-icon"
         (click)="openDescriptiveIconLink($event)">
    <svg-icon
      *ngIf="menuItem.descriptiveIcon"
      [class]="menuItem.descriptiveIconStyle"
      fontSize="1em"
      [key]="menuItem.descriptiveIcon">
    </svg-icon>
    <img
      [src]="menuItem.descriptiveIconSrc"
      [class]="menuItem.descriptiveIconStyle"
      *ngIf="menuItem.descriptiveIconSrc"
      alt="{{ menuItem.descriptiveIconLabel ? menuItem.descriptiveIconLabel : 'menu item descriptive icon'}}"
      height="32px"
      width="32px"
    >
    <span *ngIf="menuItem.tooltipLabel" aeroTooltipPosition="top" tabindex="0"
          attr.aria-label="{{ menuItem.tooltipLabel }}"
          aeroTooltip="{{ menuItem.tooltipLabel }}"
          role="tooltip">
      <i class="fal fa-info-circle"></i>
    </span>
  </aside>

  <p-inputSwitch
    *ngIf="menuItem.type === 'TOGGLE'"
    class="input-switch-slider"
    [ngModel]="menuItem.model"
    [readonly]="true"
  ></p-inputSwitch>
</div>
